// extracted by mini-css-extract-plugin
export var darkMode = "_10-0";